// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2753":"637e0cd8","3770":"e13ade33","4474":"97527069","4581":"9fdddaf1","5899":"7c945694","6283":"3fbd5273","6753":"fff95f4f","8052":"0343eb9e","9651":"1431c226","9847":"637e0cd8","9990":"637e0cd8"}[chunkId] + ".chunk.css";
};